const Home = () => <h1>Contact</h1>
export default Home;